import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Rx';
import { ClienteIndividualEntity } from './entities/datos_generales_individual_entity';
import { ClienteEmpresaEntity } from './entities/datos_generales_empresa_entity';
import { Headers, Http, Response, RequestOptions } from '@angular/http';
import { AuthHttp } from "angular2-jwt/angular2-jwt";
import { ClienteLogin } from '../../../views/login/cliente_login';
import { UbicacionEntity } from './entities/ubicacion_entity';
import { EstadoCivilEntity } from './entities/estado_civil_entity';
import { ConstantService } from "../../../components/common/utils/constant.service";
import {Cliente} from "../../login/cliente_login";
import { SessionStorageService } from "ngx-webstorage";

declare var jQuery: any;

@Injectable()
export class DatosGeneralesService {
    usuario: ClienteLogin;
    userMasivos: Cliente;
    private url="infoClienteIndividual";

    constructor(public authHttp: AuthHttp, private sessionStorageService: SessionStorageService) { 
         let constantService = new ConstantService();  
        this.url = constantService.API_ENDPOINT + this.url;
    }
    datosClienteIndividual(): Observable<ClienteIndividualEntity> {
        this.userMasivos = jQuery.parseJSON(this.sessionStorageService.retrieve("usermasivos"));
        this.usuario = jQuery.parseJSON(this.sessionStorageService.retrieve("usuario"));
        let body = JSON.stringify(this.userMasivos);
        let headers = new Headers({ 'Content-Type': 'application/json', 'Authorization' : "Token " + sessionStorage.getItem("Token") });
        let options = new RequestOptions({ headers: headers });
        return this.authHttp.post(this.url +"/consultarIndividual", body, options).map(this.extractData)
            .catch(this.handleError);
    }

     actualizarClienteIndividual(clienteIndividual): Observable<boolean> {        
        let body = JSON.stringify(clienteIndividual);
        let headers = new Headers({ 'Content-Type': 'application/json', 'Authorization' : "Token " + sessionStorage.getItem("Token") });
        let options = new RequestOptions({ headers: headers });
        return this.authHttp.post(this.url +"/actualizarIndividual", body, options).map(this.extractData)
            .catch(this.handleError);
    }

    consultaEstadoCivil(): Observable<EstadoCivilEntity[]> {
        let headers = new Headers({ 'Content-Type': 'application/json', 'Authorization' : "Token " + sessionStorage.getItem("Token") });
        let options = new RequestOptions({ headers: headers });
        return this.authHttp.get(this.url + "/consultaEstadoCivil",options).map(this.extractData)
            .catch(this.handleError);
    }

    consultaProvincias(): Observable<UbicacionEntity[]> {
        let headers = new Headers({ 'Content-Type': 'application/json', 'Authorization' : "Token " + sessionStorage.getItem("Token") });
        let options = new RequestOptions({ headers: headers });
        return this.authHttp.get(this.url + "/consultaProvincias",options).map(this.extractData)
            .catch(this.handleError);
    }

    consultaCiudades(provCod):Observable<UbicacionEntity[]> {
        let headers = new Headers({ 'Content-Type': 'application/json', 'Authorization' : "Token " + sessionStorage.getItem("Token") });
        let options = new RequestOptions({ headers: headers });
        return this.authHttp.get(this.url +"/consultaCiudades/"+provCod,options).map(this.extractData)
            .catch(this.handleError);
    }

     consultaSectores(ciuCod):Observable<UbicacionEntity[]> {
        let headers = new Headers({ 'Content-Type': 'application/json', 'Authorization' : "Token " + sessionStorage.getItem("Token") });
        let options = new RequestOptions({ headers: headers });
        return this.authHttp.get(this.url +"/consultaSectores/"+ciuCod,options).map(this.extractData)
            .catch(this.handleError);
    }

    datosClienteEmpresa(): Observable<ClienteEmpresaEntity> {
        this.userMasivos = jQuery.parseJSON(this.sessionStorageService.retrieve("usermasivos"));
        this.usuario = jQuery.parseJSON(this.sessionStorageService.retrieve("usuario"));
        let body = JSON.stringify(this.userMasivos);
        let headers = new Headers({ 'Content-Type': 'application/json', 'Authorization' : "Token " + sessionStorage.getItem("Token") });
        let options = new RequestOptions({ headers: headers });
        return this.authHttp.post(this.url +"/consultarEmpresa", body, options).map(this.extractData)
            .catch(this.handleError);
    }
    actualizarClienteEmpresa(clienteEmpresa): Observable<boolean> {        
        let body = JSON.stringify(clienteEmpresa);
        let headers = new Headers({ 'Content-Type': 'application/json', 'Authorization' : "Token " + sessionStorage.getItem("Token") });
        let options = new RequestOptions({ headers: headers });
        return this.authHttp.post(this.url +"/actualizarEmpresa", body, options).map(this.extractData)
            .catch(this.handleError);
    }

    private extractData(res: Response) {
        let body = res.json();
        return body || {};
    }
    private handleError(error: any) {
        return Observable.throw(error);
    }
}


// WEBPACK FOOTER //
// C:/Fuentes Git/TecnienLineaV2.0/front-consulta-en-linea/src/app/views/masivos/datosGenerales/datos-generales.service.ts